import { render, staticRenderFns } from "./BrewerStore.vue?vue&type=template&id=772d4809&"
import script from "./BrewerStore.vue?vue&type=script&lang=js&"
export * from "./BrewerStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports